import { PictureOutlined } from '@ant-design/icons';
import { ReactComponent as PhotoAlternate } from '@assets/icons/FunnelType/photoAlternate.svg';
import { Col, Flex, Typography } from 'antd';

export interface EmptyUploadImageProps {
  error?: boolean;
  invalid?: boolean;
}
export const EmptyUploadImage = ({ error, invalid }: EmptyUploadImageProps) => {
  return (
    <Col
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        gap: '8px',
        height: '60px',
        paddingInline: '8px',
      }}
    >
      {error && (
        <Flex
          gap={12}
          style={{ justifyContent: 'center', alignItems: 'center' }}
        >
          <Flex
            vertical
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              border: '1px solid red',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <PictureOutlined style={{ color: 'red' }} />
          </Flex>
          <Typography.Text style={{ textAlign: 'left', color: 'red' }}>
            Erro ao tentar subir o arquivo.&nbsp;
            <Typography.Text underline style={{ color: 'red' }}>
              Faça upload novamente.
            </Typography.Text>
          </Typography.Text>
        </Flex>
      )}
      {invalid && (
        <Flex
          gap={12}
          style={{ justifyContent: 'center', alignItems: 'center' }}
        >
          <Flex
            vertical
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              border: '1px solid #D89614',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <PictureOutlined style={{ color: '#D89614' }} />
          </Flex>
          <Typography.Text style={{ textAlign: 'left', color: '#D89614' }}>
            Extensão incompatível.&nbsp;
            <Typography.Text underline style={{ color: '#D89614' }}>
              Faça upload novamente.
            </Typography.Text>
          </Typography.Text>
        </Flex>
      )}
      {!error && !invalid && (
        <Flex align='center' gap={8}>
          <PhotoAlternate />
          <Typography.Text style={{ textAlign: 'left' }}>
            Arraste seu asset aqui ou{' '}
            <Typography.Text underline style={{ color: '#177DDC' }}>
              faça upload de um arquivo
            </Typography.Text>
          </Typography.Text>
        </Flex>
      )}
    </Col>
  );
};
